import api from './api'

// Look up per-store prices for a scanned barcode (EAN-13 / EAN-8).
// Returns the product payload:
//   { ean, brand, name, quantity,
//     chains: [{ chain, min_price, max_price, unit_price, best_price_30,
//                store_count, on_promo, cheapest_store, price_changed_at,
//                chain_checked_at, stale, verified, badge }],
//     unverified_prices: [ ...same shape, source-quality-demoted chains... ] }
// Location options (precedence, backend-side): precise { lat, lon(, radius) }
// → { city } → national (none). Pass {} for national.
export async function getProduct(ean, { lat, lon, radius, city } = {}) {
  let params
  if (lat != null && lon != null) {
    params = { lat, lon }
    if (radius != null) params.radius = radius
  } else if (city) {
    params = { city }
  }
  const { data } = await api.get(`/api/products/${ean}`, { params })
  return data
}
